import React from "react";
import { Box } from "@chakra-ui/react";
import { motion, useReducedMotion } from "framer-motion";
import ConfettiCelebration from "./ConfettiCelebration";

const MotionBox = motion.create(Box);

export default function CelebrationEffects() {
  const reduceMotion = useReducedMotion();

  return <>
    <ConfettiCelebration/>
    {!reduceMotion && <Box aria-hidden="true" position="fixed" inset="0" overflow="hidden" pointerEvents="none" zIndex="0">
      {[0, 0.65].map((delay) => <MotionBox
        key={delay}
        position="absolute"
        left="50%"
        top="50%"
        boxSize="120px"
        ml="-60px"
        mt="-60px"
        rounded="full"
        border="4px solid"
        borderColor="red.300"
        initial={{ scale: 0.45, opacity: 0 }}
        animate={{ scale: 5.8, opacity: [0, 0.5, 0] }}
        transition={{ duration: 2.2, delay, repeat: Infinity, repeatDelay: 0.15, ease: "easeOut" }}
      />)}
    </Box>}
  </>;
}
